import { Box, Divider, Typography } from '@material-ui/core';
import { SGSTooltip, Loader, SGSTable, SGSSelect, SGSYearPicker, SGSTabs, SGSTab, SGSTabPanel, SGSCard, SGSColumnFilter, Filter, SGSButton, SGSHelpButton } from 'components';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cotisation, menusService } from '../../../core/services';
import styles from './CotisationsCall.module.scss';
import classnames from 'classnames';
import { Cell, ColumnInterface, Row } from 'react-table';
import { Cotisation } from 'core/models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faCheckCircle, faCircle as farCircle, faFile, faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faClock, faEuroSign, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import SGSDrawer from 'components/SGSDrawer';
import { initCotisation } from 'core/models/Cotisation';
import { addYears, getYear, subYears } from 'date-fns';
import { exportCotisations } from 'core/services/cotisation';
//import { exportCotisations } from 'core/services/cotisation';
import { getRisk, getCotisationStatus } from 'core/utils/utils';
import { useQueryConf } from 'core/utils/useQuery';
import { useQuery } from 'react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppContext } from 'core/contexts';

type Props = {};

function getStatusIcon(value: string, faSize: SizeProp = 'lg') {
    //
    let icon = null;
    if (value === 'P') {
        icon = <FontAwesomeIcon icon={faCheckCircle} size={faSize} className={styles.green} />;
    } else if (value === 'D') {
        icon = <FontAwesomeIcon icon={faCheckCircle} size={faSize} className={styles.blue} />;
    } else if (value === 'I') {
        icon = <FontAwesomeIcon icon={farCircle} size={faSize} className={styles.red} />;
    } else if (value === 'A') {
        icon = (
            <span className={classnames('fa-layers fa-fw', `fa-${faSize}`, styles.orange)}>
                <FontAwesomeIcon icon={faFile} />
                <FontAwesomeIcon icon={faClock} transform="shrink-5 down-1 left-3" stroke="white" strokeWidth="15" />
            </span>
        );
        // } else if (val === 'attente validation') {
        //     icon = (
        //         <span className={classnames('fa-layers fa-fw', `fa-${faSize}`, styles.orange)}>
        //             <FontAwesomeIcon icon={faCheckCircle} />
        //             <FontAwesomeIcon icon={faCircle} transform="shrink-6 left-5 up-6" color="white" />
        //             <FontAwesomeIcon icon={faClock} transform="shrink-6 left-5 up-6" stroke="white" strokeWidth="25" />
        //         </span>
        //     );
        // } else if (val === 'règlement en cours') {
        //     icon = (
        //         <span className={classnames('fa-layers fa-fw', `fa-${faSize}`, styles.blue)}>
        //             <FontAwesomeIcon icon={faLongArrowAltRight} transform="shrink-3 down-5" />
        //             <FontAwesomeIcon icon={faEuroSign} transform="shrink-5 up-5 left-1" />
        //         </span>
        //     );
        // } else if (val === 'modifier déclaration') {
        //     icon = (
        //         <span className={classnames('fa-layers fa-fw', `fa-${faSize}`, styles.blue)}>
        //             <FontAwesomeIcon icon={faFile} />
        //             <FontAwesomeIcon icon={faEuroSign} transform="shrink-8 down-2 left-1" />
        //             <FontAwesomeIcon icon={faPencilAlt} transform="shrink-6 right-7" stroke="white" strokeWidth="10" />
        //         </span>
        //     );
        // } else if (val === 'déclaration tardive') {
        //     icon = <FontAwesomeIcon icon={faCalendarTimes} size={faSize} className={styles.darkorange} />;
    } else {
        icon = <FontAwesomeIcon icon={faQuestionCircle} size={faSize} className={styles.darkorange} />;
    }
    return icon;
}

function SelectColumnFilter({ column: { filterValue, setFilter, preFilteredRows, id } }) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const { t } = useTranslation();
    const options = React.useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row) => {
            options.add(row.values[id]);
        });
        return Array.from(options.values());
    }, [id, preFilteredRows]);

    return (
        <SGSSelect
            value={filterValue || ''}
            displayEmpty
            onChange={(e) => {
                setFilter(e.target.value || undefined);
            }}
            className="w-100"
            options={[
                { value: '', label: t('cotisations.call.all') },
                ...Array.from(options).map((o: any) => ({
                    value: o,
                    label: id === 'etat' ? <>{getStatusIcon(o)}&nbsp;</> : o,
                })),
            ]}
        />
    );
}

function getBackground(state: string) {
    state = state.toLowerCase();
    if (state === 'payée') {
        return styles.statusBackground__paid;
    }
    if (state === 'impayée') {
        return styles.statusBackground__unpaid;
    }
    if (state === 'attente déclaration') {
        return styles.statusBackground__waiting;
    }
}

const CotisationsCall: React.FC<Props> = () => {
    const { t } = useTranslation();
    const { user } = useAppContext();
    const [cotisations, setCotisations] = useState([]);
    const [loading, setLoading] = useState(false);
    const quarters = [
        {
            number: 1,
            startDate: moment('01/01/2021', 'DD/MM/YYYY'),
            endDate: moment('31/03/2021', 'DD/MM/YYYY'),
        },
        {
            number: 2,
            startDate: moment('01/04/2021', 'DD/MM/YYYY'),
            endDate: moment('30/06/2021', 'DD/MM/YYYY'),
        },
        {
            number: 3,
            startDate: moment('01/07/2021', 'DD/MM/YYYY'),
            endDate: moment('30/09/2021', 'DD/MM/YYYY'),
        },
        {
            number: 4,
            startDate: moment('01/10/2021', 'DD/MM/YYYY'),
            endDate: moment('31/12/2021', 'DD/MM/YYYY'),
        },
    ];
    const month = moment().month() + 1;
    const [quarterSelected, setQuarterSelected] = useState(Math.ceil(month / 3) - 1);
    const handleChangeTab = (_event: React.ChangeEvent<{}>, newValue: number) => {
        setQuarterSelected(newValue);
    };
    const [selectedYear, setSelectedYear] = useState(new Date());
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [selectedCotisation, setSelectedCotisation] = useState<Cotisation>(initCotisation);

    const toggleDrawer = (open: boolean) => {
        setDrawerOpened(open);
    };

    const handleDetails = (row: Row<Cotisation>) => {
        setSelectedCotisation(row.original);
        toggleDrawer(true);
    };

    const handleExport = () => {
        setDownloading(true);
        exportCotisations(getYear(selectedYear), activeFilters).then((data) => {
            setDownloading(false);
            const url = window.URL.createObjectURL(
                new Blob([data as BlobPart], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                }),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `cotisations_${getYear(selectedYear)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const columns = useMemo<ColumnInterface<Cotisation>[]>(
        () => [
            {
                Header: '',
                accessor: 'etat',
                Filter: SelectColumnFilter,
                filter: 'includes',
                maxWidth: 50,
                disableFilters: true,
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} justify-content-center`,
                Cell: ({ value }: Cell<Cotisation>) => {
                    return (
                        <SGSTooltip className="text-center" title={<Box>{t(getCotisationStatus(value.charAt(0)))}</Box>}>
                            <Box>{getStatusIcon(value.charAt(0), '2x')}</Box>
                        </SGSTooltip>
                    );
                },
            },
            {
                Header: t('cotisations.call.referencePrime'),
                accessor: (row: Cotisation) => row.numPrime.toString(),
                minWidth: 150,
                disableFilters: true,
                headerClassName: styles.tableBorderRight__header,
                className: `justify-content-center ${styles.tableBorderRight__cell}`,
                sortType: (rowA, rowB) => {
                    const cotisationA = rowA.original.numPrime.substring(8);
                    const cotisationB = rowB.original.numPrime.substring(8);
                    if (cotisationA > cotisationB) return -1;
                    if (cotisationB > cotisationA) return 1;
                    return 0;
                },
            },
            {
                Header: t('cotisations.call.risk'),
                accessor: 'contrat.type',
                disableFilters: true,
                maxWidth: 100,
                headerClassName: styles.tableBorderRight__header,
                className: `justify-content-center ${styles.tableBorderRight__cell}`,
                Cell: ({ value }: Cell<Cotisation>) => {
                    let risk = '';
                    if (value === 'S') {
                        risk = t('cotisations.call.health');
                    } else if (value === 'P') {
                        risk = t('cotisations.call.foresight');
                    }
                    return <Box className={styles.risk}>{risk}</Box>;
                },
            },
            {
                Header: t('cotisations.call.socialReason'),
                accessor: 'souscripteur.libelle',
                disableFilters: true,
                filter: 'fuzzyText',
                headerClassName: styles.tableBorderRight__header,
                className: styles.tableBorderRight__cell,
                Cell: ({ value, row: { original: row } }: Cell<Cotisation>) => (
                    <SGSTooltip
                        title={
                            <Box>
                                <Box>
                                    {t('cotisations.call.siret')} : {row.souscripteur.siret}
                                </Box>
                                {/* <Box>{t('cotisations.call.telegram')} : </Box> */}
                            </Box>
                        }
                    >
                        <Box>{value}</Box>
                    </SGSTooltip>
                ),
            },
            {
                Header: t('cotisations.call.contract'),
                accessor: 'contrat.lbContrat',
                headerClassName: styles.tableBorderRight__header,
                className: 'justify-content-center',
                disableFilters: true,
                Cell: ({ value, row: { original: row } }: Cell<Cotisation>) => {
                    return (
                        <SGSTooltip
                            title={
                                <Box>
                                    <Box>
                                        {t('cotisations.call.startDate')} : {row.dateDebut ? moment(row.contrat.dtDebutValidite, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                                    </Box>
                                    <Box>
                                        {t('cotisations.call.endDate')} :{' '}
                                        {row.contrat.dtFinValidite ? moment(row.contrat.dtFinValidite, 'YYYY-MM-DD').format('DD/MM/YYYY') : t('cotisations.call.inProgress')}
                                    </Box>
                                    <Box>
                                        {t('cotisations.call.college')} : {row.contrat.lbCollege}
                                    </Box>
                                    {/* <Box>
                                        {t('cotisations.call.tariff')} : {row.montant}
                                    </Box> */}
                                </Box>
                            }
                        >
                            <Box>{value}</Box>
                        </SGSTooltip>
                    );
                },
            },
            {
                Header: t('cotisations.call.amount'),
                accessor: 'montant',
                className: ({ row: { original: row } }: Cell<Cotisation>) => {
                    return `justify-content-center ${row.etat === 'impayée' ? styles.amountContainerRed : styles.amountContainerBlue}`;
                },
                minWidth: 180,
                disableFilters: true,
                sortType: (rowA, rowB) => {
                    if (rowA.original.montant > rowB.original.montant) return -1;
                    if (rowB.original.montant > rowA.original.montant) return 1;
                    return 0;
                },
                Footer: (info: any) => {
                    const total = React.useMemo(() => Number(info.rows.reduce((sum, row) => row.original.montant + sum, 0)).toLocaleString(undefined, { minimumFractionDigits: 2 }), [info.rows]);
                    return (
                        <Box display="flex" justifyContent="center">
                            <Box>
                                <Box>{t('cotisations.call.total')}</Box>
                                <Box>{total} €</Box>
                            </Box>
                        </Box>
                    );
                },
                Cell: ({ value, row: { original: row } }: Cell<Cotisation>) => (
                    <SGSTooltip
                        title={
                            <Box>
                                {t('cotisations.call.mode')} : {row.type}
                            </Box>
                        }
                    >
                        <Box className={classnames(styles.amount, row.etat === 'impayée' ? styles.amountRed : styles.amountBlue)}>
                            {Number(value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                            })}{' '}
                            €
                        </Box>
                    </SGSTooltip>
                ),
            },
            {
                Header: '',
                accessor: 'none',
                className: 'p-0 align-items-stretch',
                minWidth: 45,
                maxWidth: 45,
                disableFilters: true,
                disableSortBy: true,
                Cell: ({ row }: Cell<Cotisation>) => {
                    return (
                        <div className={styles.actions}>
                            <SGSTooltip title={<Box>{t('details')}</Box>}>
                                <div className={styles.actions__menu} onClick={() => handleDetails(row)}>
                                    <FontAwesomeIcon icon={faEllipsisV} size="lg" />
                                </div>
                            </SGSTooltip>
                        </div>
                    );
                },
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t],
    );

    const getCotisations = () => {
        if (!selectedYear) return;
        setLoading(true);
        cotisation
            .getCotisations(getYear(selectedYear), activeFilters)
            .then((response: any) => {
                setCotisations(Object.values(response));
            })
            .finally(() => setLoading(false));
    };

    const { isLoading: isLoadingSouscripteurs, data: dataSouscripteurs } = useQuery([user.login, 'souscripteurs'], async () => await menusService.getMenuSouscripteurs(), useQueryConf);

    const filterableColumnLabels = {
        // TODO :: refactoring etat (use etat P,I,A...)
        etat: {
            value: t('cotisations.call.status'),
            type: 'autocomplete',
            options: [
                { value: 'Payé', label: 'Payé' },
                { value: 'Impayé', label: 'Impayé' },
                // { value: 'Sans suite', label: 'En attente' },
                // { value: 'Attente', label: 'Sans suite' },
            ],
            isLoading: false,
        },
        numPrime: { value: t('cotisations.call.reference'), type: 'input' },
        'cotisation.idContrat': { value: t('cotisations.call.contract'), type: 'input' },
        nomSouscripteur: {
            value: t('affiliations.affiliates.societyName'),
            type: 'autocomplete',
            options: dataSouscripteurs || [],
            isLoading: isLoadingSouscripteurs,
        },
        'contrat.typ': {
            value: t('affiliations.affiliates.risk'),
            type: 'autocomplete',
            options: [
                { value: 'S', label: 'Santé' },
                { value: 'P', label: 'Prévoyance' },
            ],
            isLoading: false,
        },
    };

    const [activeFilters, setActiveFilters] = useState<Filter[]>([]);

    const methods = useForm({
        defaultValues: {},
    });

    useEffect(() => {
        getCotisations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedYear, activeFilters]);

    return (
        <>
            <SGSHelpButton />
            <Box>
                <Box display="flex" justifyContent="center" alignItems="baseline">
                    <FormProvider {...methods}>
                        <SGSYearPicker
                            variant="inline"
                            format="yyyy"
                            value={selectedYear}
                            disableToolbar
                            onChange={setSelectedYear}
                            views={['year']}
                            disabled={loading}
                            onYearDecrement={() => setSelectedYear(subYears(selectedYear, 1))}
                            onYearIncrement={() => setSelectedYear(addYears(selectedYear, 1))}
                        ></SGSYearPicker>
                    </FormProvider>
                </Box>
                <Box display="flex" className="my-2" justifyContent="space-between" alignItems="center">
                    <FormProvider {...methods}>
                        <SGSColumnFilter columns={filterableColumnLabels} className="mr-5" filters={activeFilters} onFiltersChange={setActiveFilters} disabled={loading} />
                    </FormProvider>
                </Box>

                <Box justifyContent="center">
                    <Loader loading={loading} small>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <Box display="flex" justifyContent="center" width="100%" alignItems="end">
                                <SGSTabs value={quarterSelected} onChange={handleChangeTab}>
                                    {quarters.map((q) => (
                                        <SGSTab
                                            label={t('cotisations.call.date_from_to', {
                                                startDate: moment(q.startDate).format('DD/MM'),
                                                endDate: moment(q.endDate).format('DD/MM'),
                                            })}
                                        />
                                    ))}
                                </SGSTabs>
                                <SGSButton color="primary" onClick={() => handleExport()} icon="far fa-file-excel fa-lg" className={styles.export} loading={downloading}>
                                    {t('global.export')}
                                </SGSButton>
                            </Box>
                            {quarters.map((q) => {
                                const cotisationsbyQuarter = cotisations.find((c) => c.trimestre === q.number);
                                const rows = cotisationsbyQuarter ? cotisationsbyQuarter.cotisations : [];
                                return (
                                    <SGSTabPanel value={quarterSelected} index={q.number - 1} className="w-100">
                                        <SGSCard color="default" className="w-100">
                                            <SGSTable onRowClick={(row) => handleDetails(row)} columns={columns} data={rows}></SGSTable>
                                        </SGSCard>
                                    </SGSTabPanel>
                                );
                            })}
                        </Box>
                    </Loader>
                </Box>
                <SGSDrawer open={drawerOpened} toggleDrawer={toggleDrawer}>
                    <Box className={styles.summary} display="flex" flexDirection="column" gridGap="15px">
                        <Box>
                            <Box
                                display="flex"
                                alignItems="center"
                                gridGap="10px"
                                borderRadius="25px 25px 25px 25px"
                                width="fit-content"
                                className={classnames(getBackground(selectedCotisation.etat), styles.statusBackground, 'mb-2')}
                            >
                                {getStatusIcon(selectedCotisation.etat.charAt(0), '2x')}
                                <Typography>{t(getCotisationStatus(selectedCotisation.etat.charAt(0)))}</Typography>
                            </Box>
                            <Typography variant="h3">Appel de cotisation</Typography>
                            <Divider className={styles.divider} />
                        </Box>
                        <Box>
                            <Typography>
                                <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                                {t('cotisations.call.cotisationPeriod')}
                                <span className={styles.strong}>
                                    {moment(selectedCotisation.dateDebut).format('DD/MM/YYYY')}
                                    {' - '}
                                    {moment(selectedCotisation.dateFin).format('DD/MM/YYYY')}
                                </span>
                            </Typography>
                        </Box>
                        <Box className={styles.summary__contrat}>
                            <Typography className="mb-2 p-1">
                                {t('cotisations.call.contract')} :<span className={classnames(styles.amountBlue, styles.strong)}> {selectedCotisation.contrat.lbContrat} </span>
                            </Typography>
                            <Typography className="mb-1 p-1">
                                {t('cotisations.call.risk')} :<span className={styles.strong}> {t(getRisk(selectedCotisation.contrat.type))}</span>
                            </Typography>
                            <Typography className={styles.amountDetail}>
                                {t('cotisations.call.amount')} : <span className={classnames(styles.amount, styles.amountBlue, 'ml-2')}>{selectedCotisation.montant} €</span>
                            </Typography>
                            <Box className={selectedCotisation.etat.charAt(0) === 'P' ? styles.summary__detailsPaid : styles.summary__detailsUnpaid}>
                                {selectedCotisation.etat.charAt(0) === 'P' && (
                                    <Box display="flex" flexDirection="column" gridGap="30px">
                                        <Box>
                                            <Typography>
                                                <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 fa-fw" />
                                                {t('cotisations.call.checkoutDate')}
                                                {selectedCotisation.datePay && <span className={styles.strong}>{moment(selectedCotisation.datePay).format('DD/MM/YYYY')}</span>}
                                            </Typography>
                                            <Typography>
                                                <FontAwesomeIcon icon={faEuroSign} className="mr-1 fa-fw" />
                                                {t('cotisations.call.checkoutMode')}
                                                <span className={styles.strong}>{selectedCotisation.type}</span>
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}
                                {!(selectedCotisation.etat.charAt(0) === 'P') && (
                                    <Box>
                                        <Typography>
                                            <Box display="flex" justifyContent="space-between" className="p-1">
                                                <Box display="flex" alignItems="center">
                                                    <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                                                    <Box>{t('cotisations.call.dueDate')} :</Box>
                                                </Box>
                                                <span className={styles.strong}>{moment(selectedCotisation.dateEcheance).format('DD/MM/YYYY')}</span>
                                            </Box>
                                        </Typography>
                                        {selectedCotisation.etat.charAt(0) === 'I' && (
                                            <>
                                                <Typography>
                                                    <Box display="flex" justifyContent="space-between" className="p-1">
                                                        <Box display="flex" alignItems="center">
                                                            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                                                            <Box>{t('cotisations.call.unpaidDate')} :</Box>
                                                        </Box>
                                                        <span className={styles.strong}>{'Valeur non renseignée'}</span>
                                                    </Box>
                                                </Typography>
                                                <Typography>
                                                    <Box display="flex" justifyContent="space-between" className={classnames(styles.statusBackground__waiting, 'p-1')}>
                                                        <Box display="flex" alignItems="center">
                                                            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                                                            <Box className={styles.strong}>{t('cotisations.call.formalNoticeDate')} :</Box>
                                                        </Box>
                                                        <span className={styles.strong}>{'Valeur non renseignée'}</span>
                                                    </Box>
                                                </Typography>
                                            </>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </SGSDrawer>
            </Box>
        </>
    );
};

export default CotisationsCall;
